module.exports = __webpack_public_path__ + "static/media/marketcast.035ad65f.png";


//////////////////
// WEBPACK FOOTER
// ./src/new_components/generic/png/marketcast.png
// module id = 7349
// module chunks = 4